//       SUMMARY TABLE
// =========================
// 1. Functions to check diffrent kind of inputs in bloc
// 2. Error handling
// 3. Next bloc system
// 4. Global variable instantiation
// =========================


// 1. Functions to check diffrent kind of inputs in bloc

  function check_inputs(bloc, target) {
    let valide = 0;
    //inputs = bloc.find('input:not([type=hidden]):not([type=radio]):not([type=checkbox]):not([data-optional=1])')
    const inputs = bloc.find('.text-box > input[type=text]:not([data-optional=1])')
    let error = false;

    inputs.each(function() {
      if (($(this).val() || '').length) {
        clear_errors($(this).parent());
        valide++
      }
      if (target) {
        error = false
        if ($(this).val() !== null) { // TODO we check for null because of tests && jquery.inputmask for user_info_short_tel
          if ($(this).val().length === 0) error = true
        }
        if (error) {
          $(this).parent().addClass('error')
        }
        if ($(this).attr('id') === target.attr('id')) {
          target = false
        }
      }
    })

    return (inputs.length === valide)
  }
  function check_radios(bloc, target) {
    let valide = 0
    const family = []
    const inputs = bloc.find('input[type=radio]:not([data-optional=1])')

    inputs.each(function() {
      const name = $(this).attr('name')
      if ($.inArray(name, family) === -1) family.push(name)
      if ($(this).is(':checked')) {
        valide++
        $('[name="' + name + '"]').parent('label').removeClass('error')
      }
      if (target) {
        if (!$('[name="' + name + '"]').is(':checked')) {
          $('[name="' + name + '"]').parent('label').addClass('error')
        }
        if ($(this).attr('id') === target.attr('id')) {
          target = false
        }
      }
    })
    // console.log(' | ' + bloc.attr('class') + ': check_radios', family.length, valide)
    return (family.length === valide)
  }
  function check_checkbox(bloc, target) {
    const family = {}, inputs = bloc.find('input[type=checkbox]:not([data-optional=1])')
    inputs.each(function() {
      const name = $(this).attr('name').substring(0, $(this).attr('name').lastIndexOf('['))
      family[name] = family[name] || 0
    })
    bloc.find('input[type=checkbox]').each(function() {
      const name = $(this).attr('name').substring(0, $(this).attr('name').lastIndexOf('['))
      if ($(this).is(':checked')) family[name]++
    })
    // console.log(' | ' + bloc.attr('class') + ': check_checkbox', Object.keys(family).length, $.map(family, function(val) { return val > 0 ? true : null }).length)
    return (Object.keys(family).length === $.map(family, function(val) { return val > 0 ? true : null }).length)
  }
  function check_select(bloc, target) {
    let valide = 0
    const inputs = bloc.find('select:not([data-optional=1])')

    inputs.each(function() {
      const id = $(this).attr('id').replace('_3i', '').replace('_2i', '').replace('_1i', ''),
          val = $(this).val();

      if (val && val.length) {
        clear_errors($(this).parent());
        valide++
      }
      if (target) {
        if ($(this).val().length === 0) {
          $(this).parent().addClass('error')
        }
        if ($(this).attr('id') === target.attr('id')) {
          target = false
        }
      }
    })
    return (inputs.length === valide)
  }

// 2. Error handling
    function clear_errors($elem) {
      $elem.find('.error').addBack().removeClass('error');
      $elem.find('.error-message').remove();
    }

    function error_message($label, $input, message, show_error, $elem) {
      const $target = (typeof $elem === 'undefined') ? ($label.length ? $label : $input) : $elem

      $input.parent().addClass('error')

      if (show_error) $target.after($('<p class="error-message" data-id="' + $input.attr('id') + '"/>').text(message))
    }

    function errors_handling($self, response, type, show_error, $elem) {
      if (response) {
        $.each(response, function (key, data) {
          const $label = $self.find('label[for=' + type + '_' + key + ']'),
              $input = $self.find('#' + type + '_' + key)

          $.each(data, function (_, message) { error_message($label, $input, message, show_error || false, $elem) })
        })
      }
    }

    function error_handling($self, response, $elem) {
      if (response) {
        $self.find('input').parent().addClass('error')
        $elem.after($('<p class="error-message"/>').text(response))
      }
    }

    function add_clear_errors($self, callback, $elem) {
      $self.on('ajax:success', function() {
        const $target = (typeof $elem === 'undefined') ? $(this) : $elem

        clear_errors($target.parent())
      }).on('ajax:error', function(e, xhr, status, error) {
        const $target = (typeof $elem === 'undefined') ? $(this) : $elem

        clear_errors($target.parent())

        if (typeof callback === 'function') callback($(this), xhr)
      })
    }

    function add_popin_loading($self, callback, $elem) {
      if ($self.is('a')) {
        $self.on('click', function() {
          const $target = (typeof $elem === 'undefined') ? $(this) : $elem

          $target.parents('.popin').children('.popin-loading').addClass('loading show')
        })
      }

      $self.on('submit', function() {
        const $target = (typeof $elem === 'undefined') ? $(this) : $elem

        $target.parents('.popin').children('.popin-loading').addClass('loading show')
      }).on('ajax:success', function(e, data, status, xhr) {
        const $target = (typeof $elem === 'undefined') ? $(this) : $elem

        $target.parents('.popin').children('.popin-loading').removeClass('loading show');

        if (typeof callback === 'function') callback($(this), xhr)
      }).on('ajax:error', function() {
        const $target = (typeof $elem === 'undefined') ? $(this) : $elem

        $target.parents('.popin').children('.popin-loading').removeClass('loading show')
      })
    }

// 3. Next bloc system

  function nextbloc(bloc, scroll, callback) {
    if (!bloc.hasClass('done')) {
      bloc.addClass('done')

      const $next = $('.bloc.init').first()
      if ($next.length == 0) return

      if (typeof callback === "function") callback ()

      $next.removeClass('init')
      if (scroll) $('body,html').delay(200).animate({ scrollTop: $next.offset().top - 200 }, 600)
    }
  }

// 4. Global variable instantiation

module.exports = {
  check_inputs: check_inputs,
  check_radios: check_radios,
  check_checkbox: check_checkbox,
  check_select: check_select,

  nextbloc: nextbloc,
  clear_errors: clear_errors,
  error_handling: error_handling,
  errors_handling: errors_handling,
  add_clear_errors: add_clear_errors,
  add_popin_loading: add_popin_loading
};
